var exports = {
  "iE": "x28a7bf27--1ffe59--wrapper",
  "kL": "x28a7bf27--1ffe59--container",
  "Qs": "x28a7bf27--1ffe59--content",
  "wm": "x28a7bf27--1ffe59--logo",
  "Qq": "x28a7bf27--1ffe59--text",
  "Zd": "x28a7bf27--1ffe59--form",
};

module.exports = exports;
